import {
  appendPropagatedParameters,
  addLocaleToPath,
  getCurrentLocale,
} from 'app/history';

// Base path of the "add to Google Wallet" page. It is served by a separate
// project behind an nginx reverse proxy (like the new checkout / update
// payment method page), so links to it must be full-page navigations, not
// client-side react-router transitions.
export const GOOGLE_WALLET_PATH = '/reservations';

/**
 * Build the URL to the "add to Google Wallet" page for a reservation. The
 * path carries the currently active locale (e.g. `/en-us/reservations/<id>/
 * google-wallet`) and any params that must be propagated across pages (`ref`,
 * `wl`, `utm_*`, ...) from the current URL.
 * @param  {string} reservationId
 * @return {string}
 */
export const getGoogleWalletUrl = (reservationId) => {
  const path = addLocaleToPath(
    `${GOOGLE_WALLET_PATH}/${reservationId}/google-wallet`,
    getCurrentLocale()
  );
  return appendPropagatedParameters(path);
};
